// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2632":"b5fcd86478012e21","5618":"0aeee47629e62a53"}[chunkId] + ".js";
};